module.exports = __webpack_public_path__ + "static/img/logoImage.4e569fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logoImage.png
// module id = 185
// module chunks = 1